/** @format */

import { CITIES_EXTERNAL } from '@/@ducks/locations/constants';
import { getCityFormattedName } from '@/@ducks/locations/helpers';
import { TLocale } from '@/utils/gatsby/types';
import { TTranslation, useAppTranslation } from '@/i18n/declarations';

const getCityRedirectCode = (city: string, locale: string) => {
  const { t } = useAppTranslation();
  const cityName = locale === 'it' ? t(`${city}` as TTranslation).toLowerCase() : city;
  switch (cityName) {
    case 'venice':
      return 'venice';
    case 'venezia':
      return 'venezia';
    case 'como':
      return 'como-campus';
    case 'trento':
      return 'trento';
    case 'parma':
      return 'parma';
    case 'siena':
      return 'siena';
    case 'ferrara':
      return 'ferrara';
    case 'trieste':
      return 'trieste';
    default:
      return '';
  }
};

const linkRedirect = ({ rawCityName, locale }: { rawCityName: string; locale: string }) => {
  const redirectCampusCity = getCityRedirectCode(rawCityName, locale);
  return locale === 'it'
    ? `https://studenthousing.joivy.com/it/${redirectCampusCity}/`
    : `https://studenthousing.joivy.com/en/${redirectCampusCity}/`;
};

export const utilityCitiesRedirect = ({
  city,
  locale,
  rawCityName,
}: {
  city: string;
  locale: string;
  rawCityName: string;
}) => {
  const isRedirectCity = CITIES_EXTERNAL.some(town => getCityFormattedName(town.name, locale as TLocale) === city);
  const redirectCities = linkRedirect({ rawCityName, locale });

  return { isRedirectCity, redirectCities };
};
